export class SectionIndex {

    constructor() {
        let sectionIndexLinks: NodeListOf<HTMLElement> = document.querySelectorAll('.c-section-index a');
        const headerElement = document.querySelector('header');

        sectionIndexLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                let target = link.dataset.scrollTo;
                if (target) {
                    let yOffset = 0;
                    if (headerElement) {
                        yOffset = (headerElement.getBoundingClientRect().height * -1);
                    }

                    const scrollToElement = document.getElementById(target);
                    if (scrollToElement) {
                        const y = scrollToElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }
            });
        });

    }

}

new SectionIndex();
